<template>
    <section id="contact-popup">
      <div id="container-contacts-form" class="container d-flex">
        <div class="text-align-start formHeader">
          <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
          <span style="vertical-align: middle; font-weight: 600">Contatos</span>
        </div>
        <div id="div-title">
          <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
          <h2 id="container-title">Cadastro de Contatos</h2>
        </div>
        <form action="" id="contacts-form">
          <div class="input-group">
            <label for="contactName">Nome</label>
            <input class="form-control" name="contactName" type="text" v-model="contact.name"
              placeholder="Insira o nome do contato" required>
          </div>
          <div class="input-group">
            <label for="contactPhone">Telefone</label>
            <input class="form-control" name="contactPhone" type="text" v-model="contact.phone"
              v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(11) 9XXXX-XXXX" required>
          </div>
  
          <div class="input-group mt-2">
            <label>Grupo</label>
            <select class="form-control" name="grupo" id="grupo" v-model="contact.grupo" style="flex: 1">
              <option value="0">-- Selecione um Grupo --</option>
              <option value="Vendedor">Vendedor</option>
              <option value="Cliente B2B">Cliente B2B</option>
              <option value="Cliente B2C">Cliente B2C</option>
              <option value="Cliente Revenda">Cliente Revenda</option>
            </select>
          </div>
  
          <div class="input-group mt-2">
            <label>Divisão</label>
            <select class="form-control" name="divisao" id="divisao" v-model="contact.divisao" style="flex: 1">
              <option value="0">-- Selecione uma Divisão --</option>
              <option value="Auto">Auto</option>
              <option value="Cargo">Cargo</option>
              <option value="Manutenção">Manutenção</option>
              <option value="Metal">Metal</option>
              <option value="MD Marcenaria">MD Marcenaria</option>
              <option value="MD Marmoraria">MD Marmoraria</option>
              <option value="RV Contrução">RV Contrução</option>
              <option value="RV Mobilidade">RV Mobilidade</option>
            </select>
          </div>
  
          <div class="input-group mt-2">
            <label>Estado</label>
            <select class="form-control" name="estado" id="estado" v-model="contact.estado" style="flex: 1">
              <option value="0">-- Selecione um Estado --</option>
              <option value="Acre">Acre</option>
              <option value="Alagoas">Alagoas</option>
              <option value="Amapá">Amapá</option>
              <option value="Amazonas">Amazonas</option>
              <option value="Bahia">Bahia</option>
              <option value="Ceará">Ceará</option>
              <option value="Distrito Federal">Distrito Federal</option>
              <option value="Espírito Santo">Espírito Santo</option>
              <option value="Goiás">Goiás</option>
              <option value="Maranhão">Maranhão</option>
              <option value="Mato Grosso">Mato Grosso</option>
              <option value="Mato Grosso do Sul">Mato Grosso do Sul</option>
              <option value="Minas Gerais">Minas Gerais</option>
              <option value="Pará">Pará</option>
              <option value="Paraíba">Paraíba</option>
              <option value="Paraná">Paraná</option>
              <option value="Pernambuco">Pernambuco</option>
              <option value="Piauí">Piauí</option>
              <option value="Rio de Janeiro">Rio de Janeiro</option>
              <option value="Rio Grande do Norte">Rio Grande do Norte</option>
              <option value="Rio Grande do Sul">Rio Grande do Sul</option>
              <option value="Rondônia">Rondônia</option>
              <option value="Roraima">Roraima</option>
              <option value="Santa Catarina">Santa Catarina</option>
              <option value="São Paulo">São Paulo</option>
              <option value="Sergipe">Sergipe</option>
              <option value="Tocantins">Tocantins</option>
            </select>
          </div>
  
          <div class="input-group">
            <label for="contactCPD">CPD</label>
            <input class="form-control" name="contactCPD" type="text" v-model="contact.cpd"
              placeholder="Insira o CPD do cliente">
          </div>
  
          <div class="input-group mt-2">
            <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
              <option value="id">ID</option>
              <option value="cpf">CPF</option>
              <option value="cnpj">CNPJ</option>
            </select>
            <input v-if="idCpf == 'cpf'" class="form-control" name="contactKey" type="text" v-model="contact.unique_key"
              v-mask="'###.###.###-##'" placeholder="XXX.XXX.XXX-XX" style="flex: 4">
            <input v-if="idCpf == 'cnpj'" class="form-control" name="contactKey" type="text" v-model="contact.unique_key"
              v-mask="'##.###.###/####-##'" placeholder="XX.XXX.XXX/XXXX-XX" style="flex: 4">
            <input v-if="idCpf == 'id'" class="form-control" name="contactKey" type="text" v-model="contact.unique_key"
              v-mask="" placeholder="ID do Contato" style="flex: 4">
          </div>
  
          <div v-if="saving">
            <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
          </div>
  
          <div v-else>
            <button type="submit" class="btn btn-success" id="btn-save" form="chamadoForm"
              @click.prevent="saveContact()"><i class="fas fa-check"></i>
              Salvar
            </button>
  
            <button type="submit" class="btn btn-danger" id="btn-cancel" form="chamadoForm"
              @click.prevent="resetContact()"><i class="fas fa-window-close fa-fw"></i>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </section>
  </template>
  
  <script>
  
  import { mapActions, mapGetters } from 'vuex';
  import VueTheMask from 'vue-the-mask';
  Vue.use(VueTheMask);
  
  export default {
    name: "ContatosRapido",
    props: ['addWppContact'],
    data() {
      return {
        contact: {
          name: "",
          phone: "",
          unique_key: "",
          grupo: 0,
          divisao: 0,
          estado: 0,
          cpd: ""
        },
        saving: false,
        idCpf: "cpf"
      }
    },
    components: {
      ...mapGetters(['getContacts']),
    },
    methods: {
      ...mapActions(['transferOptions']),
      checkForm: function () {
        if (this.contact.name == '') {
          Swal.fire({
            html: 'O campo "Nome" não foi preenchido!',
            type: "warning",
            showCloseButton: true,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
          });
          
          return false;
        }
        if (this.contact.phone == '') {
          Swal.fire({
            html: 'O campo "Telefone" não foi preenchido!',
            type: "warning",
            showCloseButton: true,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
          });
  
          return false;
        }
        return (this.contact.phone.length == 14) || (this.contact.phone.length == 15);
      },
      saveContact: function () {
        if (this.checkForm()) {
          this.saving = true;
          axios.post("dialer/saveContact", this.contact).then(({ data }) => {
            Swal.fire({
              type: "success",
              title: "Feito!",
              text: "Contato salvo com sucesso!"
            }).then(() => {
              this.saving = false;
              this.contact.name = "";
              this.contact.phone = "";
              this.contact.unique_key = "";
              this.contact.grupo = 0;
              this.contact.divisao = 0;
              this.contact.estado = 0;
              this.contact.cpd = "";
              this.idCpf = "cpf";
              this.$emit('closeContacts');
            });
  
          })
        }
      },
      resetContact: function () {
        Swal.fire({
          title: 'Deseja descartar as informações?',
          text: 'Você perderá as alterações não salvas!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: 'rgb(28,134,154)',
          confirmButtonText: 'Sim, descartar',
          cancelButtonText: 'Voltar ao formulário'
        }).then((result) => {
          if (result.value) {
            this.contact.name = "";
            this.contact.phone = "";
            this.contact.unique_key = "";
            this.contact.grupo = 0;
            this.contact.divisao = 0;
            this.contact.estado = 0;
            this.contact.cpd = "";
            this.idCpf = "cpf"
            this.$emit('closeContacts');
          }
        })
      },
      async setClientData(client) {
        if ((client.phone || client.name) && client.type == 'chat') {
  
          let phoneArr = client.phone.split('@');
          let phoneEdited = phoneArr[0].substr(2);
  
          this.contact = {
            'name': client.name,
            'phone': phoneEdited,
          }
        }
      }
    },
    computed: {
      ...mapGetters([
        'getContacts',
      ]),
      ...mapActions(['setMessage'])
    },
  
    watch: {
      idCpf() {
        this.contact.unique_key = "";
      },
      addWppContact(data) {
        if (data) {
          const phone = data.phone
          const phoneEdited = '+' + phone;
  
          this.contact = {
            'name': data.name,
            'phone': phoneEdited,
          }
        }
      },
    },
  }
  </script>
  
  <style scoped>
  #contact-popup {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 5px;
    right: 29vw;
  }
  
  .formHeader {
    background-color: rgb(28, 134, 154);
    border-top: 3px solid #f38630;
    color: white;
    padding: 0.2em;
    display: flex;
    border-radius: 20px 20px 0px 0px
  }
  
  .input-group {
    width: 90%;
    align-self: center;
    line-height: 2.55;
  }
  
  #container-contacts-form {
    width: 35vw;
    border: solid 2px lightgray;
    border-radius: 25px;
    text-align: center;
    flex-direction: column;
    margin: 10px;
    padding: 0;
    background-color: white;
  }
  
  #saving {
    color: rgb(28, 134, 154);
    font-size: 16px;
    text-align: center
  }
  
  #div-title {
    display: flex;
    flex-direction: column;
    margin: 20px;
  }
  
  #contacts-form {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 61vh;
    overflow-y: auto;
  }
  
  #buttonGroup {
    display: flex;
    justify-content: center;
  }
  
  #btn-save {
    border: solid 2px #008000;
    border-radius: 20px;
    background-color: #008000;
    color: white;
    transition: 0.5s
  }
  
  #btn-save:hover {
    color: #008000;
    background-color: white;
  
  }
  
  #btn-cancel {
    border: solid 2px #b30000;
    border-radius: 20px;
    background-color: #b30000;
    color: white;
    transition: 0.5s
  }
  
  #btn-cancel:hover {
    color: #b30000;
    background-color: white;
  
  }
  
  section {
    display: flex;
    justify-content: center;
  }
  
  h2 {
    color: rgb(28, 134, 154)
  }
  
  label {
    margin: 10px;
    font-size: 16px;
    font-weight: 500;
  }
  
  select {
    align-self: center;
  }
  
  input {
    width: 40px;
    align-self: center;
  }
  
  button {
    width: 120px;
    margin: 20px;
    border-radius: 10px !important
  }
  </style>
  